import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FacebookIcon(props: IconProps) {
    return <Icon {...props} iconKey={"facebook"}/>
}
